/**
 * Sticky Cart Button Observer (強化版)
 * メインのカートに追加ボタンが画面上部20%に来たらstickyボタンを表示
 * 既存のJavaScriptを完全に上書き
 */
(function() {
  'use strict';
  
  // 商品ページでのみ実行
  const productForm = document.querySelector('[data-product-featured]');
  if (!productForm) return;
  
  let currentState = 'hidden'; // 現在の状態を追跡
  let forceControlActive = false; // 強制制御が有効かどうか
  
  // 初期化を遅延実行（既存のスクリプトの後に実行）
  function initStickyCartObserver() {
    // メインのカートに追加ボタンを取得（data-atc-form）
    const mainAddToCartButton = document.querySelector('[data-atc-form]');
    if (!mainAddToCartButton) {
      console.warn('Sticky Cart Observer: メインのカートボタンが見つかりません');
      // フォールバック: 他のセレクタを試す
      const fallbackButton = document.querySelector('.t4s-product-form__submit');
      if (fallbackButton) {
        console.log('Sticky Cart Observer: フォールバックボタンを使用');
        startObserving(fallbackButton);
      }
      return;
    }
    
    console.log('Sticky Cart Observer: メインボタン検出 -', mainAddToCartButton);
    startObserving(mainAddToCartButton);
  }
  
  function startObserving(mainAddToCartButton) {
    // Stickyボタンを取得
    const stickyAtc = document.querySelector('[data-sticky-addtocart]');
    if (!stickyAtc) {
      console.warn('Sticky Cart Observer: Stickyボタンが見つかりません');
      return;
    }
    
    console.log('Sticky Cart Observer: 初期化完了', {
      mainButton: mainAddToCartButton,
      stickyButton: stickyAtc
    });
    
    forceControlActive = true;
    
    // 既存のクラス制御を上書きするための強制表示関数
    function forceShowSticky() {
      if (!forceControlActive) return;
      
      currentState = 'shown';
      stickyAtc.classList.add('is--shown');
      stickyAtc.style.setProperty('transform', 'translate3d(0, 0, 0)', 'important');
      stickyAtc.style.setProperty('opacity', '1', 'important');
      stickyAtc.style.setProperty('pointer-events', 'auto', 'important');
      stickyAtc.style.setProperty('visibility', 'visible', 'important');
      
      console.log('Sticky Cart Observer: ボタン表示');
    }
    
    function forceHideSticky() {
      if (!forceControlActive) return;
      
      currentState = 'hidden';
      stickyAtc.classList.remove('is--shown');
      stickyAtc.style.removeProperty('transform');
      stickyAtc.style.removeProperty('opacity');
      stickyAtc.style.removeProperty('pointer-events');
      stickyAtc.style.removeProperty('visibility');
      
      console.log('Sticky Cart Observer: ボタン非表示');
    }
    
    // メインボタンの位置をチェックする関数
    function checkButtonPosition() {
      const rect = mainAddToCartButton.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const threshold = viewportHeight * 0.9; // 画面上部20%
      
      if (rect.top < threshold && rect.bottom < threshold) {
        // メインボタンが画面上部20%より上にある（見えていない）
        if (currentState !== 'shown') {
          forceShowSticky();
        }
      } else {
        // メインボタンが画面内にある
        if (currentState !== 'hidden') {
          forceHideSticky();
        }
      }
    }
    
    // Intersection Observer の設定
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const rect = entry.boundingClientRect;
        const viewportHeight = window.innerHeight;
        const threshold = viewportHeight * 0.2;
        
        if (rect.top < threshold && rect.bottom < threshold) {
          // 完全に画面上部20%より上
          forceShowSticky();
        } else {
          // 画面内に見えている
          forceHideSticky();
        }
      });
    }, {
      threshold: [0, 0.1, 0.5, 1],
      rootMargin: '-20% 0px 0px 0px'
    });
    
    observer.observe(mainAddToCartButton);
    
    // スクロールイベントでも監視（念のため）
    let ticking = false;
    function handleScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          checkButtonPosition();
          ticking = false;
        });
        ticking = true;
      }
    }
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // 定期的にチェック（既存のJSが強制的に変更する場合に備えて）
    setInterval(checkButtonPosition, 100);
    
    // MutationObserverでクラスの変更を監視して強制的に戻す
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // 既存のJSがクラスを変更したら、すぐに正しい状態に戻す
          setTimeout(checkButtonPosition, 0);
        }
      });
    });
    
    mutationObserver.observe(stickyAtc, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
    
    // ページ読み込み時の初期状態を設定
    setTimeout(() => {
      checkButtonPosition();
    }, 100);
  }
  
  // 複数の読み込みタイミングで試行
  function tryInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(initStickyCartObserver, 1000);
      });
    } else {
      setTimeout(initStickyCartObserver, 1000);
    }
  }
  
  tryInit();
  
  // さらに遅延しても実行（テーマによっては非同期で要素が追加される）
  setTimeout(initStickyCartObserver, 2000);
  
})();

